/**
 * @generated SignedSource<<fc640ea670355f0b5c0c52d6b4dc4272>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildCard_build$data = {
  readonly changeMessageTitle: string;
  readonly id: string;
  readonly repository: {
    readonly " $fragmentSpreads": FragmentRefs<"RepositoryNameChipNew_repository" | "RepositoryOwnerChipNew_repository">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"BuildBranchNameChipNew_build" | "BuildStatusChipNew_build" | "CreatedTime_build" | "Duration_build" | "Hash_build">;
  readonly " $fragmentType": "BuildCard_build";
};
export type BuildCard_build$key = {
  readonly " $data"?: BuildCard_build$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildCard_build">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildCard_build",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "changeMessageTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RepositoryNameChipNew_repository"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RepositoryOwnerChipNew_repository"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreatedTime_build"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Hash_build"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Duration_build"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuildStatusChipNew_build"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuildBranchNameChipNew_build"
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "f35da8f38afdbcfd5a080261c6c102e4";

export default node;
